import React, { useEffect, useState, useRef } from 'react'
import { MDXProvider } from '@mdx-js/react'
import { DidomiSDK } from '@didomi/react'

import { Seo } from '@/components/common/seo'
import { SyntaxHighlighter } from '@/components/ui/syntax-highlighter'
import FloatingLinks from '@/components/common/layout/floating-links'
import { getDidomiNoticeId } from '@/utils/didomi-notice-id'
import { CTAKey } from '@/components/common/cta'

import { BaseLayout } from './base'

type BaseMDXLayoutProps = {
  withSidebar?: boolean
  headerCTAKey?: CTAKey
}

export const BaseMDXLayout: React.FC<BaseMDXLayoutProps> = (props) => {
  const { children, withSidebar = false, headerCTAKey = 'default' } = props
  const [noticeId, setNoticeId] = useState<string>()
  const isMountedRef = useRef(false)

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    getDidomiNoticeId().then((value) => {
      // set notice id only if component is mounted
      if (isMountedRef.current) {
        setNoticeId(value)
      }
    })
  }, [])

  return (
    <MDXProvider components={{ code: SyntaxHighlighter }}>
      <FloatingLinks />
      {!!noticeId && (
        <DidomiSDK
          apiKey="8878f527-7872-49a5-abd4-f6b2e56cb64a"
          iabVersion={2}
          noticeId={noticeId}
          gdprAppliesGlobally={true}
        />
      )}
      <Seo title={'GIPHY Developers'} />
      <BaseLayout withSidebar={withSidebar} headerCTAKey={headerCTAKey}>
        {children}
      </BaseLayout>
    </MDXProvider>
  )
}
